<template>
  <div class="flex flex-col w-254 mx-auto">
    <div class="ml-1.5 mb-4">
      <ReturnButton />
    </div>
    <div class="flex gap-2">
      <div class="h-full w-45">
        <SettingsSide :active="currentCom" @change="sideChange" />
      </div>
      <div class="flex-1 size-full glass-frosted rounded-5xl h-fit">
        <component :is="MainComponents[currentCom]" />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
  import { nextTick, ref } from 'vue'
  import { useRoute } from 'vue-router'
  import SettingsSide from './Side.vue'
  import MainComponents from './main/index'
  import ReturnButton from '@/components/ReturnButton.vue'

  const route = useRoute()
  const initialSub = typeof route.query.sub === 'string' ? route.query.sub : 'theme'
  const currentCom = ref<string>(initialSub in MainComponents ? initialSub : 'theme')
  const sideChange = (com: string) => {
    currentCom.value = ''
    nextTick(() => {
      currentCom.value = com
    })
  }
</script>

<style lang="scss" scoped></style>
